/*
 Note:
 This component is included directly into the sources of this project to simplify the
 build process.

 License:
 Copyright 2019, Indoqa Software Design und Beratung GmbH

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
/* tslint:disable:max-line-length */
import {OegbvBaseTheme} from '@oegbv/ui-shared'
import {IStyle} from 'fela'
import * as React from 'react'
import {useFela} from 'react-fela'

interface Props {
  active?: boolean
  color?: string
  hover?: boolean
  hoverColor?: string
  verticalCenter?: boolean
  size: number
  style?: IStyle
}

export const ThemedIcon: React.FC<Props> = ({
  active = false,
  size,
  hover = true,
  children,
  color,
  hoverColor,
  verticalCenter = false,
  style = {},
}) => {
  const {theme, css} = useFela<OegbvBaseTheme>()
  const getHoverColor = () => {
    if (hover) {
      return hoverColor || theme.colors.iconHighlighted
    }
    return color || theme.colors.icon
  }
  const getColor = () => {
    if (color) {
      return color
    }
    if (active) {
      return theme.colors.iconHighlighted
    }
    return theme.colors.icon
  }
  const iconStyle: IStyle = {
    display: verticalCenter ? 'flex' : 'inline',
    '& svg': {
      fill: getColor(),
      height: size,
      width: size,
    },
    '& svg:hover': {
      fill: getHoverColor(),
    },
    ...style,
  }
  return <span className={css(iconStyle)}>{children}</span>
}
